import axiosInstance from "./axiosInstance";

let api = axiosInstance()


export const EmployerForm = async(data, abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.post(`/EmployerForm`, data, config)
  }


